const data = [
    {
        name: "Rajma Chawal",
        category: "Lunch",
        price: 168,
        desc: "Really good Rajma served with Rice + Salad + Mint chutney + Garlic yogurt. Comfort meal at it's best!",
        img: "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_1024/hr14fsiayijfr968g6my"
    },
    {
        name: "Poha",
        category: "Breakfast",
        price: 109,
        desc: "Flattened rice roasted with peanuts, onions, mustard seeds and curry leaves for a quick, high-carb low-fat bite.",
        img: "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_1024/vexwc0vlsl4jza7jtlwk"
    },
    {
        name: "Kulche Chole",
        category: "Snacks",
        price: 165,
        desc: "North Indian style delicious chatpate chole served with 2 warm fresh bread kulchas. Sufficient for one.",
        img: "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_1024/upfrieug0plbuoxd5zx3"
    },
    {
        name: "Rabdi Jalebi",
        category: "Breakfast",
        price: 60,
        desc: "Made by deep-frying multi grain batter (plain flour or all-purpose flour) batter in pretzel or circular shapes, which are then soaked in sugar syrup with rabdi.",
        img: "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_1024/fwgxomqrxufmm96xvtr8"
    },
    {
        name: "Kadhi Chawal",
        category: "Lunch",
        price: 160,
        desc: "Fried onion pakoras cooked in rich creamy and sour yogurt gravy served with plain rice.",
        img: "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_1024/gkrpccdouatjuenvoimg"
    },
    {
        name: "Chole Bhature",
        category: "Lunch",
        price: 189,
        desc: "A combination of chole masala & fried white flour bread",
        img: "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_1024/f1cwqs6wt2ijefdxrjnr"
    },
    {
        name: "Dum aloo",
        category: "Lunch",
        price: 370,
        desc: "Potato dumplings slow cooked in creamy tomato & cashew nut gravy, served with mirchi naan. All naan or rotis will not be available between 4:30 pm To 7:30 pm will be replaced with paratha.",
        img: "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_1024/hfvk2mzlfnxqsqhkxj3m"
    },
    {
        name: "Khichdi",
        category: "Dinner",
        price: 169,
        desc: "A Healthy combination of Lentils and Rice perfectly blended with Spices. Served with a unique combination of achar, papad churi and gur.",
        img: "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_1024/m3nbmedwpawjlgwkliqg"
    },
    {
        name: "Dosa",
        category: "Dinner",
        price: 93,
        desc: "The classic. Thin pancake prepared from fermented batter stuffed with prepartion of potatoes & onions, . Served with chutney & sambar.",
        img: "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_1024/nl5nj083ij1e57pemt7g"
    },
    {
        name: "Aloo Paratha",
        category: "Breakfast",
        price: 139,
        desc: "Homestyle stuffed tawa aloo paratha served with curd and pickle.",
        img: "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_1024/qqocyqvxarwysijwwwap"
    },
    {
        name: "Dal Chawal",
        category: "Dinner",
        price: 149,
        desc: "Dal Tadka with Jeera Rice. Served with papad churi, gur and pickle.",
        img: "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_1024/dozojmopttmi8nkbbvw5"
    },
    {
        name: "Malai Sandwhich",
        category: "Snacks",
        price: 58,
        desc: "Sandwhich made by spreading a paste of Malai, onions, tomato, pepper, and salt on bread slices, and then toasting gently.",
        img: "https://achalafood.com/wp-content/uploads/2018/07/malai-sandwich-main-photo-2.jpg"
    }
]

export default data;